import { QuantityMetric } from "@/models/api";

export function unitDescription(quantityMetric:QuantityMetric) {
    switch(quantityMetric) {
        case QuantityMetric.Distance:
            return 'm';
        case QuantityMetric.WeightTonnes:
            return 't';
        case QuantityMetric.WeightKilograms:
            return 'kg';
        default:
            return '';
    }
}

export function coalescingUnitDescription(quantityMetric:QuantityMetric | null | undefined): string {
    switch(quantityMetric) {
        case QuantityMetric.Distance:
            return 'm';
        case QuantityMetric.WeightTonnes:
            return 't';
        case QuantityMetric.WeightKilograms:
            return 'kg';
        default:
            return '';
    }
}

export function UnitLongDescription(quantityMetric: QuantityMetric | null | undefined): string {
    switch (quantityMetric) {
        case QuantityMetric.Distance:
            return 'Metres';
        case QuantityMetric.WeightTonnes:
            return 'Tonnes';
        case QuantityMetric.WeightKilograms:
            return 'Kilograms';
        case QuantityMetric.Count:
            return 'Count';
        default:
            return 'Unknown';
    }
}

export function UnitLongRateDescription(quantityMetric: QuantityMetric | null | undefined): string {
    switch (quantityMetric) {
        case QuantityMetric.Distance:
            return 'Metres per hour';
        case QuantityMetric.WeightTonnes:
            return 'Tonnes per hour';
        case QuantityMetric.WeightKilograms:
            return 'Kilograms per hour';
        case QuantityMetric.Count:
            return 'Number per hour';
        default:
            return 'Unknown';
    }
}

export function unitLongDescription(quantityMetric:QuantityMetric){
    switch(quantityMetric){
        case QuantityMetric.Distance:
            return 'metres';
        case QuantityMetric.WeightTonnes:
            return 'tonnes';
        case QuantityMetric.WeightKilograms:
            return 'kilograms';
        default:
            return '';
    }
}

export function defaultingUnitLongDescription(quantityMetric: QuantityMetric | null | undefined, defaultValue: string = '') {
    if (quantityMetric === null || quantityMetric === undefined) {
        return defaultValue;
    }
    return unitLongDescription(quantityMetric);
}

export function defaultingUnitDescription(quantityMetric: QuantityMetric | null | undefined, defaultValue: string = '') {
    if (quantityMetric === null || quantityMetric === undefined) {
        return defaultValue;
    }
    return unitDescription(quantityMetric);
}

export function rateDescription(metric:QuantityMetric) {
    return `${unitDescription(metric)}/hr`;
}

export function isQuantity(metric:QuantityMetric | null) {
    return metric !== null
}